import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { authSelector } from '../../redux/authReducer'
import { packageSelector, getPackageList } from '../../redux/packageReducer'
import PackagesList from './List'
import { gameSelector, getAllGames } from '../../redux/gameReducer'

const Packages: React.FC = () => {
  const dispatch = useDispatch()
  const {
    packages: { items: packages },
  } = useSelector(packageSelector)
  const {
    games: { items: games },
  } = useSelector(gameSelector)
  const { status } = useSelector(authSelector)

  React.useEffect(() => {
    if (status === 200) {
      !games.length && dispatch(getAllGames(1, 150))
    }
    // eslint-disable-next-line
  }, [])

  React.useEffect(() => {
    if (status === 200) {
      !packages.length && dispatch(getPackageList())
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <PackagesList />
    </>
  )
}

export default Packages
